// Line-level diff via longest-common-subsequence.
// Returns an array of {op, text} where op is one of 'eq' | 'add' | 'del'.

function lcsTable(a, b) {
    const m = a.length;
    const n = b.length;
    const dp = Array.from({length: m + 1}, () => new Array(n + 1).fill(0));
    for(let i = m - 1; i >= 0; i--) {
        for(let j = n - 1; j >= 0; j--) {
            if(a[i] === b[j]) {
                dp[i][j] = dp[i + 1][j + 1] + 1;
            } else {
                dp[i][j] = Math.max(dp[i + 1][j], dp[i][j + 1]);
            }
        }
    }
    return dp;
}

export function lineDiff(oldText, newText) {
    const a = (oldText || '').split('\n');
    const b = (newText || '').split('\n');
    const dp = lcsTable(a, b);
    const ops = [];
    let i = 0;
    let j = 0;
    while(i < a.length && j < b.length) {
        if(a[i] === b[j]) {
            ops.push({op: 'eq', text: a[i]});
            i++; j++;
        } else if(dp[i + 1][j] >= dp[i][j + 1]) {
            ops.push({op: 'del', text: a[i]});
            i++;
        } else {
            ops.push({op: 'add', text: b[j]});
            j++;
        }
    }
    while(i < a.length) ops.push({op: 'del', text: a[i++]});
    while(j < b.length) ops.push({op: 'add', text: b[j++]});
    return ops;
}



// WEBPACK FOOTER //
// ./src/views/pages/knowledge-base/kb-line-diff.js